var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"home"}},[_c('Header'),_c('Carousel',{staticClass:"position-relative"}),_c('Simulation'),_c('Calendar'),_c('Twitter')],1)}
var staticRenderFns = []

export { render, staticRenderFns }